module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-36-55-007.b561687e.mp4";